import React, { useContext, useEffect, useRef, useState } from 'react';
import Select from "react-select";
import PageTitle from '../../Components/PageTitle';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { currentDateAndTime, decodeData, decodeUrl, encodeData, genderOptions } from '../../Constants/constants';
import CryptoJS from "crypto-js";
import { SubmitButton } from '../../Components/InputElements';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const StatutorySlab = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedDataId = decodeUrl(encodedData);
    // console.log("decodedDataId Slab",parseInt(decodedDataId));
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    // console.log("decodedData Slab",decodedData);
    const navigate = useNavigate();
    const query = useQuery();
    const statutory_slab_id = query.get("id");
    const state = query.get("state");
    const statutoryType = query.get("statutoryType");
    const [rows, setRows] = useState([]);
    const [statesRows, setStatesRows] = useState([]);
    const [designationRows, setdesignationRows] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: "",
        total_pages: "",
    });
    const [slabRows, setSlabRows] = useState([
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            contribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
    ]);
    const [formData, setFormData] = useState({
        statutoryType: null,
        slabState: null,
        slabEmployeeLevel: null,
        // slabDesignation: null,
        // slabGrade: null,
    });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [errors, setErrors] = useState({});
    const [loadingList, setLoadingList] = useState(false);
    const [loading, setLoading] = useState(false);

    const statutorySlabOptions = [
        { value: "PT", label: "PT" },
        { value: "ER LWF", label: "ER LWF" },
        { value: "EE LWF", label: "EE LWF" },
    ];
    const headOptions = [
        { value: "Fixed Component", label: "Fixed Component" },
        { value: "Earning", label: "Earning" },
        { value: "EE Statutory Deduction ", label: "EE Statutory Deduction " },
        { value: "ER Statutory Contribution ", label: "ER Statutory Contribution " },
        { value: "Other Earnings", label: "Other Earnings" },
        { value: "Other Deductions", label: "Other Deductions" },
    ];
    const employeeLevelOptions = [
        { value: "Level 1", label: "Level 1" },
        { value: "Level 2", label: "Level 2" },
        { value: "Level 3", label: "Level 3" },
        { value: "Level 4", label: "Level 4" },

    ];
    const frequencyOptions = [
        { value: "Monthly", label: "Monthly" },
        { value: "Yearly", label: "Yearly" },
        { value: "Half Year", label: "Half Year" },
        { value: "Quarterly", label: "Quarterly" },
    ];
    const monthDataOptions = [{ value: "All", label: "All" }, { value: "Jan", label: "Jan" }, { value: "Feb", label: "Feb" }, { value: "Mar", label: "Mar" }, { value: "Apr", label: "Apr" }, { value: "May", label: "May" }, { value: "Jun", label: "Jun" },
    { value: "Jul", label: "Jul" }, { value: "Aug", label: "Aug" }, { value: "Sep", label: "Sep" }, { value: "Oct", label: "Oct" }, { value: "Nov", label: "Nov" }, { value: "Dec", label: "Dec" }];


    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleMultiSelect = (fieldName, selectedOptions) => {
        console.log("selectedOptions", selectedOptions);
        if ((Array.isArray(selectedOptions) && selectedOptions?.find((val) => val?.value === "All")) || selectedOptions?.value === "All") {
            setFormData(prevFormData => ({
                ...prevFormData,
                [fieldName]: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec"
            }));
        }
        else {
            const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
            setFormData(prevFormData => ({
                ...prevFormData,
                [fieldName]: ids.join(',')
            }));
        }
        // Clear the error message for componentLocation
        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    const handleSlabChange = (index, fieldName, value) => {
        const updatedSlabRows = [...slabRows];
        updatedSlabRows[index] = {
            ...updatedSlabRows[index],
            [fieldName]: value,
        };
        setSlabRows(updatedSlabRows);
    };
    const handleSlabMultiSelect = (index, fieldName, selectedOptions) => {
        if ((Array.isArray(selectedOptions) && selectedOptions?.find((val) => val?.value === "All")) || selectedOptions?.value === "All") {
            setSlabRows(prevSlabRows => prevSlabRows.map((row, rowIndex) =>
                rowIndex === index
                    ? {
                        ...row,
                        [fieldName]: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec", // Join the selected months as a comma-separated string
                    }
                    : row // Return the row as is if it is not the targeted index
            ));
        }
        else {
            // Extract the selected month values or set an empty array if no options are selected
            const months = selectedOptions?.map(option => option.value) || [];

            // Create a shallow copy of slabRows to avoid directly mutating the state
            setSlabRows(prevSlabRows => prevSlabRows.map((row, rowIndex) =>
                rowIndex === index
                    ? {
                        ...row,
                        [fieldName]: months.join(","), // Join the selected months as a comma-separated string
                    }
                    : row // Return the row as is if it is not the targeted index
            ));
        }
    };

    const statutoryTypeRef = useRef();
    const slabStateRef = useRef();
    const slabEmployeeLevelRef = useRef();
    const slabDesignationRef = useRef();
    const earnedSlabMinRef = useRef();
    const earnedSlabMaxRef = useRef();
    const genderRef = useRef();
    const contributionRef = useRef();
    const employeeContributionRef = useRef();
    const employerContributionRef = useRef();
    const frequencyRef = useRef();
    const monthsRef = useRef();

    useEffect(() => {
        if (errors?.statutoryType) {
            statutoryTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            statutoryTypeRef.current?.focus();
        }
        if (errors?.slabState) {
            slabStateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            slabStateRef.current?.focus();
        }
        if (errors?.slabEmployeeLevel) {
            slabEmployeeLevelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            slabEmployeeLevelRef.current?.focus();
        }
        // if (errors?.slabDesignation) {
        //     slabDesignationRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     slabDesignationRef.current?.focus();
        // }
        if (errors?.earnedSlabMin) {
            earnedSlabMinRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            earnedSlabMinRef.current?.focus();

        }
        if (errors?.earnedSlabMax) {
            earnedSlabMaxRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            earnedSlabMaxRef.current?.focus();

        }
        if (errors?.gender) {
            genderRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            genderRef.current?.focus();

        }
        if (errors?.contribution) {
            contributionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            contributionRef.current?.focus();

        }
        if (errors?.employeeContribution) {
            employeeContributionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            employeeContributionRef.current?.focus();

        }
        if (errors?.employerContribution) {
            employerContributionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            employerContributionRef.current?.focus();

        }
        if (errors?.frequency) {
            frequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            frequencyRef.current?.focus();

        }
        if (errors?.months) {
            monthsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            monthsRef.current?.focus();

        }

    }, [errors]);

    const validateForm = () => {
        let errors = {}
        if (!formData?.statutoryType) {
            errors.statutoryType = "Statutory Type is required!"
            return errors
        }
        if (!formData?.slabState) {
            errors.slabState = "Slab State is required!"
            return errors
        }
        // if (!formData?.slabEmployeeLevel) {
        //     errors.slabEmployeeLevel = "Slab State is required!"
        //     return errors
        // }
        // if (!formData?.slabDesignation) {
        //     errors.slabDesignation = "Slab Designation is required!"
        //     return errors
        // }
        if (!slabRows[0]?.earnedSlabMin) {
            errors.earnedSlabMin = "Required!"
            return errors
        }
        if (!slabRows[0]?.earnedSlabMax) {
            errors.earnedSlabMax = "Required!"
            return errors
        }
        if (!slabRows[0]?.gender) {
            errors.gender = "Required!"
            return errors
        }
        if (!slabRows[0]?.contribution) {
            errors.contribution = "Required!"
            return errors
        }
        // if (!slabRows[0]?.employeeContribution) {
        //     errors.employeeContribution = "Required!"
        //     return errors
        // }
        // if (!slabRows[0]?.employerContribution) {
        //     errors.employerContribution = "Required!"
        //     return errors
        // }
        if (!slabRows[0]?.frequency) {
            errors.frequency = "Required!"
            return errors
        }
        if (!slabRows[0]?.months) {
            errors.months = "Required!"
            return errors
        }
        return errors
    }

    const getInfo = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/StatutorySlabsInfo?statutory_slab_id=${statutory_slab_id}`, { headers })
        .then((response) => {
            const { success, Statutoy_slabs } = response.data;
            console.log(response?.data);
            if (success === true) {
                console.log("Statutoy_slabs[0]", Statutoy_slabs[0]);
                setFormData({
                    statutoryType: Statutoy_slabs[0]?.statutory_type,
                    slabState: Statutoy_slabs[0]?.states_id,
                    slabEmployeeLevel: Statutoy_slabs[0]?.applicable_on_level,
                    // slabDesignation: Statutoy_slabs[0]?.designation_id,
                });
                setSlabRows(JSON.parse(Statutoy_slabs[0]?.statutory_slab_data))
                setLoadingList(false);
            } else {
                setLoadingList(false);
            }
        }).catch((error)=>{
            setLoadingList(false);
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
    }
    const getStateAndDesignation = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetPTAndLWFStateList`,{
            params:{
                page:1,
                limit:999
            },
                headers 
            })
            .then((response) => {
                const { success,data } = response.data;
                console.log(response?.data);
                if (success === true) {

                    let rows1 = data?.map((val) => {
                        return { value: val?.pt_lwf_state_id, label: val?.pt_lwf_state_title }
                    });
                    // let rows2 = response?.data?.response?.designations?.map((val) => {
                    //     return { value: val?.designation_id, label: val?.designation_title }
                    // });
                    setStatesRows(rows1);
                    // setdesignationRows(rows2);
                }
            });
    }

    useEffect(() => {
        if (statutory_slab_id) {
            setLoadingList(true);
            getInfo();
        }
        getStateAndDesignation();
    }, []);

    const handleAddSlab = (event) => {
        event.preventDefault();
        const newSlab = {
          earnedSlabMin: null,
          earnedSlabMax: null,
          gender: null,
          contribution: null,
          frequency: null,
          months: null,
          minCap: null,
          maxCap: null,
        };
        if(slabRows?.length < 15){
            setSlabRows((prevSlabRows) => [...prevSlabRows, newSlab]);
        }
        
      };

      const handleDeleteSlab = (event,index) => {
        event.preventDefault();
        if((index > 0) && 
            (
                !slabRows[index]?.earnedSlabMin &&
                !slabRows[index]?.earnedSlabMax &&
                !slabRows[index]?.gender &&
                !slabRows[index]?.contribution &&
                !slabRows[index]?.frequency &&
                !slabRows[index]?.months &&
                !slabRows[index]?.minCap &&
                !slabRows[index]?.maxCap 
            )){
            setSlabRows((prevSlabRows) => prevSlabRows.filter((_, i) => i !== index));
        }
        else if(index>0){
            Swal.fire({
                title: 'Are you sure?',
                text: "Once removed, you will not be able to recover this item!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Remove!',
                cancelButtonText: 'No, cancel!',
            }).then((result) => {
                if (result.isConfirmed) {
                    setSlabRows((prevSlabRows) => prevSlabRows.filter((_, i) => i !== index));
                }});
        }
        
      };

    const handleSubmit = (e) => {

        let data = {
            statutory_slab_id: statutory_slab_id || null,
            statutoryType: formData?.statutoryType,
            slabState: formData?.slabState,
            slabEmployeeLevel: formData?.slabEmployeeLevel,
            // slabDesignation: formData?.slabDesignation,
            slabRows: JSON.stringify(slabRows),
            date: currentDateAndTime()
        }
        const headers = apiHeaderJSON;
        // setLoading(true);
        console.log("handleSubmit ~ Data =======>>>", data);

        const errors = validateForm();
        console.log("errors 1", errors);
        if (Object.keys(errors)?.length > 0) {
            setErrors(errors);
            setLoading(false);
            return;
        }

        axios
            .post(`${apiURL}Payrolls/CreateUpdateStatutorySlabs`, data, {
                headers,
            })
            .then((response) => {
                const { success } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {
                    setSuccessMsg(response.data.message);
                    setErrorMsg(false);
                    setFormData({
                        statutoryType: '',
                        slabState: '',
                        slabEmployeeLevel: '',
                        // slabDesignation: "",
                    });
                    setSlabRows([
                        {
                            earnedSlabMin: '',
                            earnedSlabMax: '',
                            gender: '',
                            contribution: '',
                            // employeeContribution: "",
                            // employerContribution: "",
                            frequency: '',
                            months: '',
                            minCap: '',
                            maxCap: '',
                        },
                    ])

                    if (statutory_slab_id) {
                        setLoadingList(true);
                        getInfo();
                    }
                } else {
                    setSuccessMsg(false);
                    setErrorMsg(response.data.message);
                }
                setLoading(false);
            })
            .catch((error)=>{
                setLoading(false);
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });


    }

    return (
        <div>
            {!loadingList ? (
                <div class="main-content">
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={statutory_slab_id ? "Update Statutory Slab" : `Create Statutory Slab`} primary={`Home`} />
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">
                                        {statutory_slab_id ? "Update Statutory Slab" : "Create Statutory Slab"}
                                    </h4>
                                    <NavLink className="btn btn-success btn-sm" 
                                    to={`/StatutorySlabMaster?abs=${encodeData(decodedDataId)}${statutoryType && state ? `&statutoryType=${statutoryType}&state=${state}` : statutoryType? `&statutoryType=${statutoryType}`: state ? `&state=${state}` : "" }`}
                                    // onClick={()=> navigate(-1)}
                                    >
                                        <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                                    </NavLink>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form
                                                id='payrollHeadCreation'
                                                // onSubmit={(e) => handleSubmit(e)}
                                                className="row settings-form"
                                            >
                                                <div className="col-md-12 mt-4 settings-section">
                                                    <>
                                                        <div className='row settings-form'>
                                                            <div ref={statutoryTypeRef} className="col-md-4">
                                                                <label htmlFor="statutoryType" className="form-label">
                                                                    Statutory Type
                                                                </label>
                                                                <Select
                                                                    id="statutoryType"
                                                                    name="statutoryType"
                                                                    value={formData?.statutoryType ?statutorySlabOptions?.find(
                                                                        (val) => val?.value === formData?.statutoryType
                                                                    ):null}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("statutoryType", selectedOption?.value,)
                                                                    }}
                                                                    options={statutorySlabOptions}
                                                                    placeholder="Select Statutory Type"
                                                                    className={`w-100 ${errors?.statutoryType ? "is-invalid" : " "}`}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.statutoryType ? "red" : base.borderColor,
                                                                            boxShadow: errors?.statutoryType ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.statutoryType ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}

                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.statutoryType ? errors?.statutoryType : null}</div>
                                                            </div>
                                                            <div ref={slabStateRef} className="col-md-4">
                                                                <label>State</label>
                                                                {/* <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("slabState", selectedOptions)}
                                                                    placeholder="Select State"
                                                                    isMulti
                                                                    className={`${errors.slabState ? "is-invalid" : ""}`}
                                                                    options={statesRows}
                                                                    value={formData.slabState ? formData.slabState.split(',').map(id => statesRows.find(option => option.value == id)) : null}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.slabState ? "red" : base.borderColor,
                                                                            boxShadow: errors?.slabState ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.slabState ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}
                                                                /> */}
                                                                <Select
                                                                    options={statesRows}
                                                                    value={formData.slabState ? statesRows.find(option => option.value == formData.slabState) : null}
                                                                    onChange={(selectedOption) => setFormData({ ...formData, slabState: selectedOption?.value })}
                                                                    placeholder={`Select State`}
                                                                    className={`${errors.slabState ? "is-invalid" : ""}`}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.slabState ? "red" : base.borderColor,
                                                                            boxShadow: errors?.slabState ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.slabState ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}
                                                                />
                                                                {errors.slabState && <div className="text-danger">{errors.slabState}</div>}
                                                            </div>
                                                            {/* <div ref={slabStateRef} className="col-md-4">
                                                                <label>Employee Level</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("slabEmployeeLevel", selectedOptions)}
                                                                    placeholder="Select Employee Level"
                                                                    isMulti
                                                                    className={`${errors.slabEmployeeLevel ? "is-invalid" : ""}`}
                                                                    options={employeeLevelOptions}
                                                                    value={formData.slabEmployeeLevel ? formData.slabEmployeeLevel.split(',').map(id => employeeLevelOptions.find(option => option.value == id)) : null}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.slabEmployeeLevel ? "red" : base.borderColor,
                                                                            boxShadow: errors?.slabEmployeeLevel ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.slabEmployeeLevel ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}
                                                                />
                                                                {errors.slabEmployeeLevel && <div className="text-danger">{errors.slabEmployeeLevel}</div>}
                                                            </div> */}
                                                            {/* <div ref={slabDesignationRef} className="col-md-4">
                                                                <label>Designation</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("slabDesignation", selectedOptions)}
                                                                    placeholder="Select designation"
                                                                    isMulti
                                                                    className={`${errors.slabDesignation ? "is-invalid" : ""}`}
                                                                    options={designationRows}
                                                                    value={formData.slabDesignation ? formData.slabDesignation.split(',').map(id => designationRows.find(option => option.value == id)) : null}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.slabDesignation ? "red" : base.borderColor,
                                                                            boxShadow: errors?.slabDesignation ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.slabDesignation ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}
                                                                />
                                                                {errors.slabDesignation && <div className="text-danger">{errors.slabDesignation}</div>}
                                                            </div> */}
                                                            {/* <div className="col-md-4">
                                                                <label>Grades</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("slabGrade", selectedOptions)}
                                                                    placeholder="Select Grade"
                                                                    isMulti
                                                                    className={`${errors.slabGrade ? "is-invalid" : ""}`}
                                                                    options={headOptions}
                                                                    value={formData.slabGrade ? formData.slabGrade.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                />
                                                                {errors.slabGrade && <div className="text-danger">{errors.slabGrade}</div>}
                                                            </div> */}
                                                        </div>
                                                        <div className="col-lg-12 mt-4">
                                                            <div className='card '>
                                                                <div style={{ "overflowY": "auto",}}>
                                                                    <table id='slabTable' style={{ minWidth: '100%', }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">

                                                                        <tbody>
                                                                            {
                                                                                slabRows.map((row, idx) => {
                                                                                    return <tr>
                                                                                        {/* Min Slab */}
                                                                                        <td style={{ "width": "8rem" }}>
                                                                                            <div ref={earnedSlabMinRef} className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="earned_slab_min"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Min Slab
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    id="earned_slab_min"
                                                                                                    name="earned_slab_min"
                                                                                                    placeholder="Enter min"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.earnedSlabMin}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "earnedSlabMin",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    className={`form-control w-100 ${idx === 0 && errors?.earnedSlabMin ? "is-invalid" : ""}`}
                                                                                                />
                                                                                                {errors.earnedSlabMin && idx === 0 && <div className="text-danger">{errors.earnedSlabMin}</div>}
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Max Slab */}
                                                                                        <td style={{ "width": "8rem" }}>
                                                                                            <div ref={earnedSlabMaxRef} className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="earned_slab_max"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Max Slab
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    id="earned_slab_max"
                                                                                                    name="earned_slab_max"
                                                                                                    placeholder="Enter max"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.earnedSlabMax}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "earnedSlabMax",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.earnedSlabMin}
                                                                                                    className={`form-control w-100 ${idx === 0 && errors?.earnedSlabMax ? "is-invalid" : ""}`}
                                                                                                />
                                                                                                {errors.earnedSlabMax && idx === 0 && <div className="text-danger">{errors.earnedSlabMax}</div>}
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Gender */}
                                                                                        <td style={{ "width": "8rem" }}>
                                                                                            <div ref={genderRef} className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="gender"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Gender
                                                                                                </label>
                                                                                                <Select
                                                                                                    id="gender"
                                                                                                    name="gender"
                                                                                                    value={genderOptions?.find((val) => val?.value === row?.gender)}
                                                                                                    onChange={(selectedOption) =>
                                                                                                      handleSlabChange(idx, "gender", selectedOption?.value)
                                                                                                    }
                                                                                                    options={genderOptions}
                                                                                                    placeholder="Select"
                                                                                                    isDisabled={!row?.earnedSlabMin}
                                                                                                    menuPortalTarget={document.body} // Render dropdown in body
                                                                                                    styles={{
                                                                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure dropdown appears on top
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Contribution */}
                                                                                        <td style={{ "width": "11rem" }}>
                                                                                            <div ref={contributionRef} className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="contribution"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Contribution
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    id="contribution"
                                                                                                    name="contribution"
                                                                                                    placeholder="Enter contribution"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.contribution}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "contribution",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.earnedSlabMin}
                                                                                                    className={`form-control w-100 ${errors?.contribution ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Employee Contribution */}
                                                                                        {/* <td style={{ "width": "11rem" }}>
                                                                                            <div ref={employeeContributionRef} className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="employee_contribution"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Employee Contribution
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    id="employee_contribution"
                                                                                                    name="employee_contribution"
                                                                                                    placeholder="Enter contribution"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.employeeContribution}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "employeeContribution",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.gender}
                                                                                                    className={`form-control w-100 ${errors?.employeeContribution ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>
                                                                                        </td> */}

                                                                                        {/* Employer Contribution */}
                                                                                        {/* <td style={{ "width": "11rem" }}>
                                                                                            <div className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="employer_contribution"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Employer Contribution
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id="employer_contribution"
                                                                                                    name="employer_contribution"
                                                                                                    placeholder="Enter contribution"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.employerContribution}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "employerContribution",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.employeeContribution}
                                                                                                    className={`form-control w-100 ${errors?.employerContribution ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>
                                                                                        </td> */}
                                                                                        {/* Frequency */}
                                                                                        <td style={{ "width": "10rem" }}>
                                                                                            <div className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="frequency"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Frequency
                                                                                                </label>
                                                                                                <Select
                                                                                                    id="frequency"
                                                                                                    name="frequency"
                                                                                                    value={frequencyOptions?.find(
                                                                                                        (val) => val?.value === row?.frequency
                                                                                                    )}
                                                                                                    onChange={(selectedOption) => {
                                                                                                        handleSlabChange(idx, "frequency", selectedOption?.value,)
                                                                                                    }}
                                                                                                    options={frequencyOptions}
                                                                                                    placeholder="Select"
                                                                                                    // ref={payrollHeadTypeRef}
                                                                                                    isDisabled={!row?.earnedSlabMin}
                                                                                                    menuPortalTarget={document.body} // Render dropdown in body
                                                                                                    styles={{
                                                                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure dropdown appears on top
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Months */}
                                                                                        <td>
                                                                                            <div className="form-check w-100 form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="months"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Months
                                                                                                </label>
                                                                                                <Select
                                                                                                    onChange={(selectedOptions) => handleSlabMultiSelect(idx, "months", selectedOptions)}
                                                                                                    placeholder="Select months"
                                                                                                    isMulti
                                                                                                    isDisabled={!row?.earnedSlabMin}
                                                                                                    className={`${errors.months ? "is-invalid" : ""}`}
                                                                                                    options={monthDataOptions}
                                                                                                    value={
                                                                                                        row?.months?.length > 0
                                                                                                            ? row.months.split(',').map(id => monthDataOptions.find(option => option.value === id))
                                                                                                            : [] // Return an empty array if `row?.months` is not a valid string
                                                                                                    }
                                                                                                    menuPortalTarget={document.body} // Render dropdown in body
                                                                                                    styles={{
                                                                                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure dropdown appears on top
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Age Criteria */}
                                                                                        {/* <td>
                                                                                            <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="age_criteria"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Age Criteria
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id="age_criteria"
                                                                                                    name="age_criteria"
                                                                                                    placeholder="Enter age"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.slabAgeCriteria}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "slabAgeCriteria",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.months}
                                                                                                    className={`form-control w-100 ${errors?.slabAgeCriteria ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>
                                                                                        </td> */}
                                                                                        {/* Age limit exceed */}
                                                                                        {/* <td>
                                                                                            <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="age_limit_exceed"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Age limit exceed
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id="age_limit_exceed"
                                                                                                    name="age_limit_exceed"
                                                                                                    placeholder="Enter age"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.slabAgeExceed}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "slabAgeExceed",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.slabAgeCriteria}
                                                                                                    className={`form-control w-100 ${errors?.slabAgeExceed ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>
                                                                                        </td> */}
                                                                                        {/* Min Cap */}
                                                                                        {/* <td >
                                                                                            <div style={{ "width": "8rem" }} className="form-check  form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="min_cap"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Min Cap
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id="min_cap"
                                                                                                    name="min_cap"
                                                                                                    placeholder="Enter min slab"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.minCap}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "minCap",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.slabAgeExceed}
                                                                                                    className={`form-control w-100 ${errors?.minCap ? "is-invalid" : ""}`}
                                                                                                />

                                                                                            </div>
                                                                                        </td> */}
                                                                                        {/* Max Cap */}
                                                                                        {/* <td>
                                                                                            <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                <label
                                                                                                    htmlFor="max_cap"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Max Cap
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id="max_cap"
                                                                                                    name="max_cap"
                                                                                                    placeholder="Enter max slab"
                                                                                                    // ref={headAgeNumberRef}
                                                                                                    value={row?.maxCap}
                                                                                                    onChange={(e) =>
                                                                                                        handleSlabChange(
                                                                                                            idx,
                                                                                                            "maxCap",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={!row?.earnedSlabMin}
                                                                                                    className={`form-control w-100 ${errors?.maxCap ? "is-invalid" : ""}`}
                                                                                                />
                                                                                            </div>

                                                                                        </td> */}
                                                                                        <td>
                                                                                            <div className=" d-flex flex-column gap-2">
                                                                                                <label
                                                                                                    // htmlFor="max_cap"
                                                                                                    className="form-check-label"
                                                                                                >
                                                                                                    Action
                                                                                                </label>
                                                                                                <button onClick={(e) => handleDeleteSlab(e,idx)} 
                                                                                                disabled={idx===0}
                                                                                                className="btn-icon btn btn-sm btn-outline-danger"> 
                                                                                                <i className="ri-delete-bin-line"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    <div className=" text-danger">{errors?.headTitleForPayslip ? errors?.headTitleForPayslip : null}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                                {/* success message */}
                                                <div style={{ width: "60%", margin: "auto" }}>
                                                    {successMsg ?
                                                        <div className=" position-relative alert alert-success mt-3" role="alert">
                                                            {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                        </div>
                                                        : null
                                                    }
                                                    {/* error message */}
                                                    {errorMsg ?
                                                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                            {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                        </div> : null
                                                    }
                                                </div>
                                                {/* save or update button */}
                                            </form>
                                            <div className=' w-100 px-3 d-flex justify-content-between align-items-center'>
                                                    {/* <button
                                                        disabled={loading}
                                                        type="submit"
                                                        className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                    >
                                                        <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                        {statutory_slab_id ? "Update" : "Save"}
                                                    </button> */}
                                                    <SubmitButton 
                                                    onClick={(e)=>{ 
                                                        if(!loading){
                                                            setLoading(true);
                                                            handleSubmit(e);
                                                        }
                                                    }}
                                                    loading={loading}
                                                    loadingMessage='Loading' buttonName={statutory_slab_id ? "Update" : "Save"} icon={'ri-save-line'} 
                                                    type='primary' iconSide='left' />
                                                    <button
                                                        disabled={loading}
                                                        onClick={(e)=>{ handleAddSlab(e) }}
                                                        className={`btn btn-success btn-label waves-effect right waves-light `}
                                                    >
                                                        <i className={`bx bx-add-to-queue label-icon align-middle fs-16 ms-2`} />{" "}
                                                        Add Slab
                                                    </button>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "90vh" }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default StatutorySlab;
